/**
 * The transcript's view of the readout store.
 *
 * `useSyncExternalStore` over one module singleton, so every message row in a
 * long transcript re-renders from the same fact and "one readout at a time" is
 * structural rather than a convention each row has to keep.
 */

import { useSyncExternalStore } from 'react';
import { readAloudSnapshot, subscribeReadAloud, type ReadAloudSnapshot } from './player';

export function useReadAloud(): ReadAloudSnapshot {
  return useSyncExternalStore(subscribeReadAloud, readAloudSnapshot, readAloudSnapshot);
}

export type { ReadAloudSnapshot } from './player';
export {
  dismissReadAloudNotice,
  readAloudKey,
  stopReadAloud,
  stopReadAloudForThread,
  toggleReadAloud,
} from './player';
